import { inject, Injectable } from '@angular/core';
import { ProfileCacheFacade } from '@lentau/profile/application/cache/profile-cache.facade';
import { CityCacheFacade } from '@lentau/city/application/city-cache.facade';
import { CitySlugCacheFacade } from '@lentau/city/application/city-slug-cache.facade';
import { MPKCacheFacade } from '@lentau/mpk/application/services/mpk-cache.facade';
import { MissionAddressModeCacheFacade } from '@lentau/address/mission-address/application/mission-address-mode-cache.facade';

@Injectable({
  providedIn: 'root',
})
export class CacheBootstrapService {
  private profileCacheFacade: ProfileCacheFacade = inject(ProfileCacheFacade);
  private cityCacheFacade: CityCacheFacade = inject(CityCacheFacade);
  private citySlugCacheFacade: CitySlugCacheFacade = inject(CitySlugCacheFacade);
  private mpkCacheFacade: MPKCacheFacade = inject(MPKCacheFacade);
  private missionAddressModeCacheFacade: MissionAddressModeCacheFacade = inject(MissionAddressModeCacheFacade);

  /** City / MPK / slug — always on CSR. */
  public initAlways(): void {
    this.mpkCacheFacade.init();
    this.cityCacheFacade.init();
    this.citySlugCacheFacade.init();
  }

  /** Profile + mission-address — Classic CSR. */
  public hydrateSessionCaches(): void {
    this.missionAddressModeCacheFacade.checkCache();
    this.profileCacheFacade.init();
  }

  /** Drop guest session caches on social OAuth callback (WEB-2294). */
  public clearSessionCaches(): void {
    this.profileCacheFacade.clear();
    this.missionAddressModeCacheFacade.clearCache();
  }

  /** Full hydrate for SSR (bot is never on social callback). Keeps legacy call order. */
  public init(): void {
    this.missionAddressModeCacheFacade.checkCache();
    this.mpkCacheFacade.init();
    this.profileCacheFacade.init();
    this.cityCacheFacade.init();
    this.citySlugCacheFacade.init();
  }
}
